import { digestList } from '@/mocks/home';

export default function DigestList() {
  return (
    <section id="digest" className="w-full bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8 max-w-5xl mx-auto">
        <div className="mb-10 md:mb-14 flex flex-col md:flex-row md:items-end md:justify-between gap-5">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-2 text-xs md:text-sm text-accent-700 mb-4">
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-file-list-3-line" />
              </span>
              参考清单
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950 leading-snug">
              一句话摘要，几类站点各自的样子
            </h2>
          </div>
          <p className="text-sm text-foreground-600 leading-relaxed max-w-sm">
            每条只留标题与短摘要，方便你快速扫一遍，判断自己到底在找哪一类。
          </p>
        </div>

        <ul className="flex flex-col">
          {digestList.map((item, i) => (
            <li key={item.id}>
              <div className="group flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6 py-6 border-t border-background-200/80 last:border-b hover:bg-background-100/50 px-2 sm:px-4 rounded-md transition-colors">
                <span className="shrink-0 w-14 text-xs text-foreground-400 font-heading">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <div className="flex-1">
                  <div className="flex flex-wrap items-center gap-3 mb-1.5">
                    <span className="px-2.5 py-0.5 rounded-full text-xs bg-accent-100 text-accent-900 whitespace-nowrap">
                      {item.label}
                    </span>
                    <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 leading-snug">
                      {item.title}
                    </h3>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.summary}</p>
                </div>
                <span className="hidden sm:flex shrink-0 w-8 h-8 items-center justify-center text-foreground-300 group-hover:text-primary-500 transition-colors">
                  <i className="ri-arrow-right-up-line" />
                </span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}